import { makeStyles } from '@material-ui/styles'
import React from 'react'
import Theme from 'core/themes/model'
import GridDefaultActionButton from './GridDefaultActionButton'

const useStyles = makeStyles<Theme>((theme) => ({
  dropdownAction: {
    background: theme.components.dropdown.background,
    border: 'none',
    '& .button-text': {
      color: theme.components.dropdown.color,
      justifyContent: 'start',
    },
  },
}))

export default function GridDefaultDropdownActionButton(props) {
  const classes = useStyles()
  return <GridDefaultActionButton {...props} className={classes.dropdownAction} />
}
